import { Checkbox, FormControlLabel, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useState, useEffect, useRef, useContext } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { store } from "../contexts/store";
import styles from "./fieldsStats.module.css";

const useStyles = makeStyles((theme) => ({
  info: {
    padding: "24px 20px",
    boxSizing: "border-box",
    color: "#949EA7",
    backgroundColor: "#fff",
    marginBottom: 8,
  },
  checkboxLabel: {
    color: "inherit",
    fontSize: 12,
    fontWeight: 600,
    width: 36,
    marginRight: 0,
  },
  graphLabel: {
    fontSize: 12,
    fontWeight: 700,
    color: "#949EA7",
  },
}));

const SustainabilityLineChart = ({ data }) => {
  const classes = useStyles();
  const {
    state: { feature },
  } = useContext(store);

  const [graphData, setGraphData] = useState({});
  // format data.
  // Extract unique dates and then add the individual values to it

  useEffect(() => {
    // console.log("data", data);
    const graphData =
      data.length === 1
        ? data[0].map((item) => {
            return { Field1: item.mean, year: item.year };
          })
        : data[0].map((item, index) => {
            return {
              Field1: item.mean,
              Field2: data[1][index].mean,
              year: item.year,
            };
          });
    //
    setGraphData(graphData);

    // console.log("graphData", graphData);
  }, [data]);

  // Get unique dates

  return (
    <div>
      {/* <div className={classes.graphLabel}>EVI, NDVI, NDMI,MI</div> */}
      {/* <ResponsiveContainer width="100%" height={200}>
        <LineChart
          width={500}
          height={200}
          data={graphData}
          syncId="anyId"
          margin={{
            top: 10,
            right: -20,
            left: 10,
            bottom: 0,
          }}
        >
          <CartesianGrid />

          <Tooltip
            wrapperStyle={{
              boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.12)",
              borderRadius: "8px",
              zIndex: 2,
            }}
            contentStyle={{
              border: "1px solid #D4D8DC",
              borderRadius: "8px",
              zIndex: 2,
            }}
          />

          <XAxis
            dataKey="year"
            stroke="#949EA7"
            type="number"
            domain={[
              data[0].reduce(
                (min, p) => (p.year < min ? p.year : min),
                data[0].year
              ),
              data[0].reduce(
                (max, p) => (p.year > max ? p.year : max),
                data[0].year
              ),
            ]}
            fontSize={12}
            tickFormatter={(year) => year}
          />

          <Line
            type="monotone"
            dataKey={"Field1"}
            stroke="#01B075"
            dot={false}
            // fill={colors[renderItem.name]}
          />
          {data.length > 1 && (
            <Line
              type="monotone"
              dataKey={"Field2"}
              stroke="#EA891D"
              dot={false}
              // fill={colors[renderItem.name]}
            />
          )}

          <YAxis
            stroke="#EEEFF1"
            tick={{ fill: "#949EA7", strokeWidth: 1 }}
            orientation="right"
            fontSize={12}
          />
        </LineChart>
      </ResponsiveContainer> */}

      <div className={classes.info}>
        <div>
          <div className={styles.ndviInfo}>
            <div className={styles.year}>
              <Typography fontSize={14} fontWeight={600}>
                FBI{" "}
              </Typography>
            </div>
            <div className={[styles.ndviMean, styles.flexCenter].join(" ")}>
              <Typography fontSize={14} fontWeight={600}>
                <img src="./green_graph.png"></img>
                {feature.id}
              </Typography>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SustainabilityLineChart;
